// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-focus-topics {
  background-color: #fff;
}
.accordion-focus-topics .card-body {
  padding: 0;
}
.accordion-focus-topics table {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}
@media (max-width: 767px) {
.accordion-focus-topics table {
    display: block;
}
}
.accordion-focus-topics .table th {
  border-bottom: 1px solid #dee2e6;
}
.accordion-focus-topics .table th,
.accordion-focus-topics .table td {
  border-top: none;
  border-right: 1px solid #d4d4d4;
  white-space: nowrap;
  background-color: #fff;
  text-align: left;
  padding: 15px;
}
.accordion-focus-topics tr:nth-child(even) td {
  background-color: #f9f9f9;
}
.accordion-focus-topics .table th:first-child {
  width: 5%;
}
.accordion-focus-topics .table th:nth-child(4), .accordion-focus-topics .table td:nth-child(4) {
  border-right: 0;
}
.accordion-focus-topics .table td:first-child {
  text-align: center;
}
.accordion-focus-topics .card-body tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
.accordion-focus-topics .table th, .accordion-focus-topics .table td {
  padding: 1.2rem;
}
.accordion-focus-topics .btn-action {
  color: #0078dc;
  padding: 0 5px 0 0;
}
.accordion-focus-topics .btn-action:hover {
  color: #56a6fc;
}
.accordion-focus-topics .btn-action--delete {
  color: #e6252e;
}
.accordion-focus-topics .btn-action--delete:hover {
  color: #ef8085;
}
.accordion-focus-topics .btn-action--disabled {
  color: #adadad;
}
.accordion-focus-topics .btn-action--disabled:hover {
  color: #adadad;
}
.accordion-focus-topics .icon-edit {
  position: absolute;
  margin-top: 5px;
}
.accordion-focus-topics .btn-action span {
  padding-left: 20px;
}
.accordion-focus-topics .actions-column {
  display: flex;
  justify-content: flex-end;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
